<div class="bulk-import-container" fxLayout="column" fxLayoutAlign="start">
  <app-import-guide [guideList]="guideList"></app-import-guide>
  <p>
    {{translateService.get(
    translations.supportModule.importGuide.asset.fields.warningFormat) | async |
    translate}}
  </p>
</div>
